import { paginationQuerySchema, searchQuerySchema } from "./pagination";
import { tenantScopeSchema } from "./tenant";

/**
 * Base shared by every list endpoint: page/limit, free-text search and the
 * super-admin tenant filter. Resources extend it with their own filters.
 */
export const listQuerySchema = paginationQuerySchema
  .extend(searchQuerySchema.shape)
  .extend(tenantScopeSchema.shape);

export type ListQuery = typeof listQuerySchema;
